/* 會員相關接口 */

import request from '@/utils/http/request'



/* List */
export async function fetchAll({ orderNo, platform, sDate, eDate, exp, page, pageSize }) {
    return await request.post('/order', {
        orderNo, platform, sDate, eDate, exp, page, pageSize
    }, {
        noAuth: false
    });
}

export async function pageExport({ orderNo, platform, sDate, eDate, exp }) {
    return await request.post('/order', { orderNo, platform, sDate, eDate, exp },
        {
            responseType: 'blob',
            noAuth: false
        }

    );
}



export async function store({ author,start_num, branch_name, deliverd_at, platform, receipted_at, url }) {
    return await request.post('/order/store', {
        author,start_num, branch_name, deliverd_at, platform, receipted_at, url
    }, {
        noAuth: false
    });
}



